import { Input, Modal, Space } from 'antd';

import Form from '../Form';
import { JobPostingActionModal } from './VacancyActions';

const FreezeVacancyModal: React.FC<JobPostingActionModal> = ({ jobPosting, form, ...props }) => {
  return (
    <Modal {...props}>
      <Space direction="vertical">
        <span>
          Ao congelar a vaga, todas as publicações serão suspensas e a vaga não receberá mais
          inscrições. Tem certeza que deseja congelar a vaga <strong>{jobPosting.name}</strong>?
        </span>
        <Form form={form}>
          <Form.Item name="comment">
            <Input.TextArea placeholder="Digite o motivo do cancelamento da vaga" defaultValue="" />
          </Form.Item>
        </Form>
        <span>
          Dica: Envie <b>um email para todos os candidatos </b> avisando que a vaga será congelada.
          Lembre-se que falta de retorno do processo seletivo é o principal motivo de insatisfação
          com a marca empregadora e isso pode afetar a sua atração no longo prazo.
        </span>
      </Space>
    </Modal>
  );
};

export default FreezeVacancyModal;
